interface Url {
    full: string;
    relative: string;
}
interface GenerateUrlParams {
    path: string;
    baseUrl: string;
    searchParameters: any
}

class UrlUtil {
    static goto(url: string, blank: boolean = false): void {
        if (url) {
            window.open(url, blank ? '_blank' : undefined)?.focus();
        }

    }


    static generateUrl(params: GenerateUrlParams): Url {

        const _url = new URL(params.path, params.baseUrl);

        const keys: string[] = Object.keys(params.searchParameters);

        for (let key of keys) {
            if (params.searchParameters[key]) {
                _url.searchParams.set(key, params.searchParameters[key])
            }
        }

        return {
            full: _url.toString(),
            relative: `${_url.pathname}/?${_url.searchParams}`
        };
    }
}

export { UrlUtil }